import React from "react";
import { FaLock } from "react-icons/fa";
import { Link, css, spacing, typographyColors, uiColors } from "../library";
import { colors, styles } from "../library/theme";

// Escala de verde (mint) da paleta que não existe nos tokens do theme — mesma
// abordagem local do `mintGlow` em AgentChat.js. mint-line reusa decorationHard.
const mint = "#4FA985";
const mintSoft = "#E7F5EE";
const mintLine = colors.decorationHard;
const accent = colors.brandDark;
const accentInk = "#B5352F";

const card = css(styles.cardShadow, {
  display: "flex",
  flexDirection: "column",
  backgroundColor: colors.white,
  border: `1px solid ${uiColors.border}`,
  borderRadius: 18,
  padding: "26px 26px 28px",
  transition: "box-shadow .18s ease, transform .18s ease",
  ":hover": { transform: "translateY(-3px)" },
});
const cardLocked = css({ backgroundColor: "#FCFBFC" });

const head = css({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 12,
  marginBottom: 16,
});
const dot = css({
  width: 11,
  height: 11,
  borderRadius: "50%",
  backgroundColor: mint,
  flex: "none",
  boxShadow: `0 0 0 4px ${mintSoft}`,
});
const dotLocked = css({
  backgroundColor: colors.greyLight,
  boxShadow: "none",
});

const pill = css({
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: "0.05em",
  textTransform: "uppercase",
  padding: "5px 11px",
  borderRadius: 999,
  flex: "none",
});
const pillFree = css({
  backgroundColor: mintSoft,
  color: mint,
  border: `1px solid ${mintLine}`,
});
const pillLocked = css({
  backgroundColor: colors.brand,
  color: typographyColors.subtitle,
  border: `1px solid ${colors.greyLight}`,
});

const title = css({
  fontWeight: 700,
  fontSize: 21,
  margin: "0 0 10px",
  lineHeight: 1.2,
  letterSpacing: "-0.01em",
  color: colors.brownDark,
});
const titleLocked = css({ color: typographyColors.subtitle });
const desc = css({
  fontSize: 14,
  color: typographyColors.defaultBody,
  margin: "0 0 28px",
  lineHeight: 1.55,
});

const btn = css({
  marginTop: "auto",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 8,
  fontSize: 14.5,
  fontWeight: 600,
  padding: "13px 18px",
  borderRadius: 12,
  border: "1px solid transparent",
  textDecoration: "none",
  cursor: "pointer",
});
// Fixa a cor no hover/focus: como o botão é um <a> (Link), o estilo global de
// link pintaria o texto de azul ao passar o mouse.
const btnPrimary = css({
  backgroundColor: accent,
  color: colors.white,
  ":hover": { color: colors.white },
  ":focus": { color: colors.white },
});
const btnGhost = css({
  backgroundColor: "transparent",
  color: accentInk,
  borderColor: colors.greyLight,
  ":hover": { color: accentInk },
  ":focus": { color: accentInk },
});

export default function AgentCard({ agent }) {
  const locked = !!agent.locked;

  return (
    <article className={css(card, locked && cardLocked)}>
      <div className={head}>
        <span className={css(dot, locked && dotLocked)} />
        {locked ? (
          <span className={css(pill, pillLocked)}>
            <FaLock size={11} /> Bloqueado
          </span>
        ) : (
          <span className={css(pill, pillFree)}>Liberado</span>
        )}
      </div>

      <h2 className={css(title, locked && titleLocked)}>{agent.name}</h2>
      {agent.description && <p className={desc}>{agent.description}</p>}

      {locked
        ? agent.cta_link && (
            <a
              className={css(btn, btnGhost)}
              href={agent.cta_link}
              target="_blank"
              rel="noopener noreferrer"
            >
              Liberar acesso
            </a>
          )
        : agent.id && (
            <Link className={css(btn, btnPrimary)} to={`/agents/${agent.id}`}>
              Conversar
            </Link>
          )}
    </article>
  );
}
